import { IconProps } from "./types";

export const EventIcon = ({
  size = 18,
  color = "currentColor",
  className,
}: IconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M19.995 30.333a.993.993 0 0 1-.853-1.507l1.4-2.333a1 1 0 0 1 1.373-.346c.48.28.627.893.347 1.373l-.36.6c3.68-.867 6.44-4.173 6.44-8.12 0-.547.453-1 1-1s1 .453 1 1c-.014 5.693-4.654 10.333-10.347 10.333M2.664 13c-.547 0-1-.453-1-1 0-5.693 4.64-10.333 10.333-10.333a.994.994 0 0 1 .853 1.507l-1.4 2.333a1 1 0 0 1-1.373.347 1 1 0 0 1-.346-1.374l.36-.6C6.41 4.747 3.65 8.054 3.65 12c.013.547-.44 1-.987 1"
      fill="#484848"
      fill-opacity=".3"
    />
    <path
      d="m14.218 18.467-4.187-2.254c-.44-.24-.974-.24-1.414 0l-4.186 2.253a.95.95 0 0 0-.494.854c0 .36.187.693.494.853l4.186 2.254c.227.12.467.173.707.173s.48-.053.707-.173l4.186-2.254a.95.95 0 0 0 .494-.853c0-.36-.2-.68-.494-.854m-6.289 4.748-3.893-1.947a.97.97 0 0 0-.933.04.96.96 0 0 0-.454.813v3.68c0 .64.347 1.213.92 1.494l3.894 1.946c.133.067.28.107.426.107.174 0 .347-.053.507-.147a.96.96 0 0 0 .453-.813v-3.68a1.62 1.62 0 0 0-.92-1.494m7.616-1.906a.97.97 0 0 0-.934-.04l-3.893 1.947a1.64 1.64 0 0 0-.92 1.493v3.68c0 .333.173.64.453.813.16.094.334.147.507.147.146 0 .293-.04.427-.107l3.893-1.946c.573-.28.92-.854.92-1.494v-3.68a.96.96 0 0 0-.453-.813m12.009-16.2-4.186-2.253c-.44-.24-.974-.24-1.414 0l-4.186 2.253a.95.95 0 0 0-.494.853c0 .36.187.694.494.854l4.186 2.253c.227.12.467.173.707.173s.48-.053.707-.173l4.186-2.253a.95.95 0 0 0 .494-.854c0-.373-.2-.693-.494-.853M21.264 9.84l-3.893-1.946a.97.97 0 0 0-.933.04.96.96 0 0 0-.454.813v3.68c0 .64.347 1.213.92 1.494l3.894 1.946c.133.067.28.107.426.107.174 0 .347-.053.507-.147a.96.96 0 0 0 .453-.813v-3.68a1.62 1.62 0 0 0-.92-1.494m7.616-1.906a.97.97 0 0 0-.934-.04L24.053 9.84c-.573.28-.92.854-.92 1.494v3.68c0 .333.173.64.453.813.16.094.334.147.507.147.146 0 .293-.04.427-.107l3.893-1.947c.573-.28.92-.853.92-1.493v-3.68a.96.96 0 0 0-.453-.813"
      fill="#484848"
      fill-opacity=".8"
    />
  </svg>
);
